<template>
  <div class="not-found-page page page-with-table p-3">
    <div class="card content-wrapper p-5 pb-5 text-center">
      <h1 style="font-size: 6em">404</h1>
      <h2>
        {{$t("Page Not Found")}}
      </h2>
    </div>
  </div>
</template>

<script>
  import AddNewButton from "../../core/components/common/AddNewButton";
  import PageHeader from "../../core/components/page-header/PageHeader";

  export default {
    name: "NotFoundPage",
    components: {PageHeader, AddNewButton},
  }
</script>

<style lang="scss" scoped>

</style>

